// eslint-disable-next-line no-unused-vars
import ChatUser from './ChatUser';

class Message {
    constructor({ id, conversationId, senderId, senderName, message, timestamp, type, imageUrl, isDeleted, isSeen }) {
        // Log if any required field is missing
        if (!id || !conversationId || !senderId || !senderName || !message || !timestamp || !type) {
            console.warn('Message entity missing fields:', { id, conversationId, senderId, senderName, message, timestamp, type });
        }

        this.id = id || 'unknown';
        this.conversationId = conversationId || 'unknown';
        this.senderId = senderId || 'unknown';
        this.senderName = senderName || 'Unknown';
        this.message = message || '';
        this.timestamp = timestamp || new Date();
        this.type = type || 'text';
        this.imageUrl = imageUrl;
        this.isDeleted = isDeleted || false;
        this.isSeen = isSeen || false;
    }
}

export default Message;
